import PropTypes from "prop-types";

export const CancerGeneCensusType = PropTypes.shape({
  version: PropTypes.string,
  cancer_syndrome: PropTypes.arrayOf(PropTypes.string),
  germline: PropTypes.bool,
  germline_tumours: PropTypes.arrayOf(PropTypes.string),
  hallmark: PropTypes.bool,
  hallmark_data: PropTypes.shape({}),
  molecular_genetics: PropTypes.string,
  mutation_types: PropTypes.arrayOf(PropTypes.string),
  other_syndrome: PropTypes.string,
  role_in_cancer: PropTypes.arrayOf(PropTypes.string),
  somatic: PropTypes.bool,
  somatic_tumours: PropTypes.arrayOf(PropTypes.string),
  tier: PropTypes.number,
  tissue_type: PropTypes.arrayOf(PropTypes.string),
  translocation_partner: PropTypes.arrayOf(PropTypes.string),
});
